import env from '../config/'

let Socket = ''
let setIntervalWesocketPush = null
let baseUrl = env.wsLink  // socket连接地址基础
let socketUrl = ''  // socket连接地址完整
let params = {}  // socket传递的参数

const object2String = (obj) => {
    if (typeof obj !== "object") return;
    let params = Object.values(obj).reduce((a, b, i) => `${a}${Object.keys(obj)[i]}=${b}&`, "");
    return params.length ? "?" + params.substring(0, params.length - 1) : "";
}
/**
 * 建立websocket连接
 * @param {string} baseUrl socket连接地址基础
 * @param {Object} params ws传递的参数
 */
export const createSocket = (wsBaseUrl, params) => {
    if (localStorage.getItem('token')) {
        let access = JSON.parse(localStorage.getItem('token'));
        params.accessToken = access.accessToken;
    }

    let baseUrlStr = wsBaseUrl == null ? baseUrl : wsBaseUrl;
    let paramsStr = params == null ? "" : object2String(params);
    socketUrl = baseUrlStr + paramsStr;

    // console.log("websocket.URL",Socket.url);
    // console.log("websocketUrl",socketUrl);
    if (Socket.url != socketUrl) {
        if (Socket) {
            Socket.close();
        }

        console.log('建立websocket连接')
        Socket = new WebSocket(socketUrl)
        Socket.onopen = onopenWS
        Socket.onmessage = onmessageWS
        Socket.onerror = onerrorWS
        Socket.onclose = oncloseWS
    } else {
        console.log('websocket已连接')
    }
}

/**打开WS之后发送心跳 */
const onopenWS = () => {
    sendPing()
}

/**连接失败重连 */
const onerrorWS = () => {
    Socket.close()
    clearInterval(setIntervalWesocketPush)
    console.log('连接失败重连中')
    if (Socket.readyState !== 3) {
        Socket = null
        createSocket(socketUrl)
    }
}

/**WS数据接收统一处理 */
const onmessageWS = e => {
    window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
            data: e.data
        }
    }))
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
    setTimeout(() => {
        if (Socket.readyState === 0) {
            connecting(message)
        } else {
            Socket.send(JSON.stringify(message))
        }
    }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = message => {
    if (Socket !== null && Socket.readyState === 3) {
        Socket.close()
        createSocket(socketUrl)
    } else if (Socket.readyState === 1) {
        Socket.send(JSON.stringify(message))
    } else if (Socket.readyState === 0) {
        connecting(message)
    }
}

/**断开 */
const oncloseWS = () => {
    clearInterval(setIntervalWesocketPush)
    Socket = ''
    console.log('websocket已断开')
}

export const closeSocket = () => {
    Socket.close();
}
/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const sendPing = (time = 5000, ping = 'ping') => {
    clearInterval(setIntervalWesocketPush)
    Socket.send(ping)
    setIntervalWesocketPush = setInterval(() => {
        Socket.send(ping)
    }, time)
}